import { apiClient } from '../config'

export type PromptParameter = {
  name: string
  currentValue: string
}

export type PromptInfo = {
  id: string
  name: string
  description: string
  category: string
  type: 'System' | 'User'
  content: string
  parameters: PromptParameter[]
  order: number
}

export const getPrompts = async (): Promise<PromptInfo[]> => {
  const response = await apiClient.get('/admin/prompts')
  return response.data.prompts
}
